import { render, staticRenderFns } from "./ApplicantShowShortHistory.vue?vue&type=template&id=492ba8a7&"
import script from "./ApplicantShowShortHistory.vue?vue&type=script&lang=js&"
export * from "./ApplicantShowShortHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports